export default "__VITE_ASSET__ByiIRVha__"